<div class="row">
  <div class="col-md-12">
    <nb-card>
      <nb-card-header class="with-button">
        <div><nb-icon icon="q-resultats" pack="custom"></nb-icon> Liste des comptes externes</div>
        <button nbButton status="success" size="small" (click)="addAction()">
          Ajouter un compte
        </button>
      </nb-card-header>
      <nb-card-body>
        <table class="stripe">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Coop</th>
              <th>Types d'animaux</th>
              <th>Type export</th>
              <th>Clé API</th>
              <th>Date expiration</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @if (!externs) {
              <tr>
                <td colspan="7">Aucun compte</td>
              </tr>
            }
            @for (extern of externs; track extern) {
              <tr>
                <td>{{ extern.name }}</td>
                <td>{{ extern.isCoop ? "Oui" : "Non" }}</td>
                <td>{{ getAnimalTypesLabel(extern.animalTypeIds) }}</td>
                <td>{{ extern.exportType }}</td>
                <td>
                  @if (extern.exportType == 'API') {
                    <span>{{ extern.apikey }}</span>
                  }
                </td>
                <td>
                  @if (extern.exportType == 'API') {
                    <span>{{
                      extern.expirationDate ? (extern.expirationDate | date: "dd/MM/yyyy") : "aucune"
                    }}</span>
                  }
                </td>
                <td class="actions">
                  <button
                    nbButton
                    status="primary"
                    class="transparent-button"
                    size="small"
                    title="Modifier"
                    [routerLink]="['/externs', 'show', extern.id]"
                    >
                    <nb-icon icon="eye-outline"></nb-icon>
                  </button>
                  <button
                    nbButton
                    status="primary"
                    class="transparent-button"
                    size="small"
                    title="Supprimer"
                    (click)="deleteAction(extern)"
                    [disabled]="extern.isProtected"
                    >
                    <nb-icon icon="trash-outline"></nb-icon>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </nb-card-body>
    </nb-card>
  </div>
</div>
